var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$attrs.type !== "text"
      ? _c(
          "input",
          _vm._b(
            {
              ref: "chatInput",
              staticClass: "chat-input",
              attrs: { required: "" },
              domProps: { value: _vm.value },
              on: {
                input: _vm.handleFormInput,
                invalid: function ($event) {
                  return _vm.$emit("invalid", $event)
                },
                focus: function ($event) {
                  return _vm.$emit("focus", $event)
                },
                blur: function ($event) {
                  return _vm.$emit("blur", $event)
                },
              },
            },
            "input",
            _vm.$attrs,
            false
          )
        )
      : _c(
          "textarea",
          _vm._b(
            {
              ref: "chatInput",
              staticClass: "chat-input",
              attrs: { required: "", rows: 1 },
              domProps: { value: _vm.value },
              on: {
                keypress: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleEnter.apply(null, arguments)
                },
                input: _vm.handleFormInput,
                focus: function ($event) {
                  return _vm.$emit("focus", $event)
                },
                blur: function ($event) {
                  return _vm.$emit("blur", $event)
                },
              },
            },
            "textarea",
            _vm.$attrs,
            false
          )
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }